import React from "react";
import { HeadingPriority } from "atoms/constants/heading-priority";
import Heading from "atoms/typography/heading";
import { DataTestAttributes } from "interfaces/data-test-attributes";
import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import useVirtualTableOfContents from "pages/notebooks/notebook-reference-panel/bookview/use-virtual-table-of-contents";
import PublicationComponentType from "utilities/enumerations/publication-component-type";
import PublicationMetadataTypeEnum from "models/interfaces/publication-metadata-types";
import useCurrentPublication from "utilities/contexts/use-current-publication";
import PublicationTypes from "constants/publication-types";
import { useOpenTocPanels } from "../../use-open-toc-panels";

const CSS_CLASS_NAME = "c-notebook-table-of-contents-header-button";
interface NotebookTableOfContentsHeaderButtonProps
    extends Pick<DataTestAttributes, "dataTestId" | "dataTestDisplaySequence"> {
    displayTitle: JSX.Element | string;
    isPublic?: boolean;
    caapsId?: number;
    publicationComponentType?:
        | PublicationComponentType
        | PublicationMetadataTypeEnum;
    parentId?: string;
}

const PublicationComponentTypeClassModifierMap = {
    [PublicationComponentType.Chapter]: "chapter",
    [PublicationComponentType.Annex]: "annex",
    [PublicationComponentType.AnnexGroup]: "annexGroup",
    [PublicationComponentType.Section]: "section",
    [PublicationComponentType.Article]: "article",
};

const NotebookTableOfContentsHeaderButton: React.FunctionComponent<
    NotebookTableOfContentsHeaderButtonProps
> = (props) => {
    const {
        dataTestId,
        displayTitle,
        caapsId,
        publicationComponentType = PublicationComponentType.Chapter,
        parentId,
    } = props;
    const { onNavigationClick } = useVirtualTableOfContents();
    const { publication } = useCurrentPublication();
    const { isPanelCollapsed, onOpenPanel, onClosePanel } = useOpenTocPanels();

    const notebookRouteToPublication = () => {
        //We never want to nav to a chapter in the NEC, we want to show articles instead
        if (
            publication.type === PublicationTypes.NEC &&
            publicationComponentType === PublicationComponentType.Chapter
        ) {
            isPanelCollapsed(caapsId!, publicationComponentType)
                ? onOpenPanel(caapsId!, publicationComponentType)
                : onClosePanel(caapsId!, publicationComponentType);
        } else {
            onNavigationClick(caapsId, publicationComponentType, parentId);
        }
    };

    return (
        <Button
            cssClassName={CSS_CLASS_NAME}
            dataTestId={dataTestId}
            style={ButtonStyles.Text}
            onClick={notebookRouteToPublication}>
            <Heading
                cssClassName={`${CSS_CLASS_NAME}__${PublicationComponentTypeClassModifierMap[publicationComponentType] ?? "chapter"}`}
                priority={HeadingPriority.Two}>
                {displayTitle}
            </Heading>
        </Button>
    );
};

export default NotebookTableOfContentsHeaderButton;
